import Vue from "vue";
import Vuex from "vuex";

import user from '@/data/user.js';
import fullQuote from '@/data/fullQuote.js';
import houseQuote from '@/data/houseQuote.js';
import travelQuote from '@/data/travelQuote.js';
import electronicsQuote from '@/data/electronicsQuote.js';
import policies from '@/data/policies.js';
import salvageBid from '@/data/salvageBid.js';
import components from '@/data/components.js';
import muendeBwino from '@/data/muendeBwino.js';
import provinces from '@/data/provinces.js';
import codedImages from '@/data/codedImages.js';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user,
    fullQuote,
    houseQuote,
    travelQuote,
    electronicsQuote,
    policies,
    salvageBid,
    components,
    muendeBwino,
    provinces,
    codedImages
  },
  getters: {
    user(state){
      return state.user
    },
    fullQuote(state){
      return state.fullQuote
    },
    houseQuote(state){
      return state.houseQuote
    },
    travelQuote(state){
      return state.travelQuote
    },
    electronicsQuote(state){
      return state.electronicsQuote
    },
    policies(state){
      return state.policies
    },
    salvageBid(state){
      return state.salvageBid
    },
    components(state){
      return state.components
    },
    muendeBwino(state){
      return state.muendeBwino
    },
    provinces(state){
      return state.provinces
    },
    codedImages(state){
      return state.codedImages
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    }
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          client_id: user.client_id,
          user_id: user.user_id,
          first_name: user.first_name,
          last_name: user.lastname,
          date_of_birth: user.dob,
          gender: user.gender,
          residential_address: user.residential_address,
          nationality: user.nationality,
          email_address: user.email,
          phone_number: user.phone_number,
          marital_status: user.marital_status,
          national_id: user.user_docs[0].document_id,
          id_type: user.user_docs[0].document_type,
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});